import {
  IsNotEmpty,
} from "class-validator";

export class CreateSetupIntentDto {
  @IsNotEmpty()
  customer_id: string;
}
